require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-wheatlessin-the-student-built-app-that-makes-gluten-free-dining-easy.json") })
        }
      }, "path---blog-meet-wheatlessin-the-student-built-app-that-makes-gluten-free-dining-easy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-wheatlessin-the-student-built-app-that-makes-gluten-free-dining-easy!./.cache/json/blog-meet-wheatlessin-the-student-built-app-that-makes-gluten-free-dining-easy.json
// module id = 978
// module chunks = 231608221292675